import PrizeBox from "../../../components/Cards/PrizeBox"
import PaginationDots from "../../../components/Pagination/PaginationDots"
import ResponsiveContainer from "../../../layouts/ResponsiveContainer"
import { RecognitionItem, recognitions } from "../../../utils/recognitions"
import useCarouselSimple from "../../../hooks/useCarouselSimple"

const Recognitions = () => {
    const { index, handleTouchStart, handleTouchMove, handleTouchEnd, setIndex } = useCarouselSimple(recognitions.length);

    return (
        <div className="h-auto w-full flex justify-center my-[3.25rem]">
            <ResponsiveContainer>
                <div className="flex flex-col justify-center items-center">
                    <h4 className="text-hlarge text-brand-green-20 mb-6">Distinciones</h4>

                    {/* Mobile carousel */}
                    <div className="flex flex-col items-center gap-4 w-full md:hidden"
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                    >
                        <div className="w-full overflow-hidden">
                            <div
                                className="flex transition-transform duration-700 ease-in-out"
                                style={{ transform: `translateX(-${index * 100}%)` }}
                            >
                                {recognitions.map((award: RecognitionItem, idx: number) => (
                                    <div key={idx} className="min-w-full px-2 sm:flex sm:justify-center">
                                        <PrizeBox year={award.year} award={award.award} organization={award.organization} />
                                    </div>
                                ))}
                            </div>
                        </div>
                        <PaginationDots
                            total={recognitions.length}
                            currentIndex={index}
                            hidden={false}
                            shape='square'
                            activeColor="bg-brand-orange-20"
                            inactiveClass="border border-brand-orange-20"
                            onDotClick={setIndex}
                        />
                    </div>

                    {/* Desktop grid */}
                    <div className="hidden md:grid grid-cols-1 md:grid-cols-3 gap-4">
                        {recognitions.map((award: RecognitionItem, idx: number) => (
                            <PrizeBox key={idx} year={award.year} award={award.award} organization={award.organization} />
                        ))}
                    </div>
                </div>
            </ResponsiveContainer>
        </div>
    )
}

export default Recognitions